<template>
  <div>
    <h1 class="page-header">{{ $t('payslipTemplate.pageTitle') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div>
            <ts-button color="info" outline @click="showForm()">
              {{ $t('addNew') }}
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record, index }">
          <td>{{ record.template_name }}</td>
          <td>{{ record.created_date }}</td>
          <td class="text-center">
            <a href="" v-tooltip="'Edit'" class="text-primary mr-2" @click.prevent="edit(record)">
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import FormComponent from './form'
import { mapState } from 'vuex'
export default {
  name: 'payslipTemplate',
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/payslipTemplate', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.payslipTemplate.search
      },
      set(newValue) {
        this.$store.commit('hr/payslipTemplate/SET_SEARCH', newValue)
        this.$store.commit('hr/payslipTemplate/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('payslipTemplate.templateName')
        },
        {
          name: this.$t('payslipTemplate.createdDate')
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 7%;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/payslipTemplate/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.showForm(record)
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '60%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/payslipTemplate/RESET_STATE')
    next()
  }
}
</script>
